import { CurrencyTokenType, useCurrencyContext } from '@apeiron/currency'
import { ApeironTooltipInfoButton } from '@apeiron/ui'
import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { useDailyCheckInContext } from '@src/contexts/reward/DailyCheckInContext'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const PriceText = styled(Typography)`
  font-size: 14px;
  color: #f1b535;
  font-weight: 500;
`

const PriceTableContainer = styled(Box)`
  padding: 4px;
`

const StyledTable = styled(Table)`
  width: 100%;
`

const StyledTableRow = TableRow

const DayText = styled(Typography)`
  color: #c4c4c4;
`

const StyledTd = styled(TableCell)`
  text-align: center;
  padding: 2px 14px;
  border-bottom: none;
`

const LightText = styled('span')`
  color: #999;
  font-weight: 400;
  font-size: 14px;
`

const StyledHead = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
`

const PriceTable = ({ makeupPrices }: TableProps) => {
  const { getApeironPrice } = useCurrencyContext()

  const { t } = useTranslation()

  return (
    <PriceTableContainer>
      <Typography>{t('reward.checkin.makeup.price_table.title')}</Typography>
      <StyledTable>
        <TableHead>
          <StyledTableRow>
            <StyledTd>
              <StyledHead>
                {t('reward.checkin.makeup.price_table.days')}
              </StyledHead>
            </StyledTd>
            <StyledTd>
              <StyledHead>
                <Trans
                  components={{
                    light: <LightText />
                  }}
                >
                  {t('reward.checkin.makeup.price_table.price_per_day')}
                </Trans>
              </StyledHead>
            </StyledTd>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {makeupPrices.map((price, index) => {
            const formattedPrice = getApeironPrice(
              CurrencyTokenType.Anima,
              price
            )

            return (
              // eslint-disable-next-line react/no-array-index-key
              <StyledTableRow key={index}>
                <StyledTd>
                  <DayText>{index + 1}</DayText>
                </StyledTd>
                <StyledTd>
                  <PriceText>{formattedPrice}</PriceText>
                </StyledTd>
              </StyledTableRow>
            )
          })}
        </TableBody>
      </StyledTable>
    </PriceTableContainer>
  )
}

const CheckInMakeupPriceTableTooltip = () => {
  const { fetchMakeupPrices, makeupPrices } = useDailyCheckInContext()

  useEffect(() => {
    fetchMakeupPrices()
  }, [])

  return (
    <ApeironTooltipInfoButton tooltipId={'anima_make_up_prices'}>
      <PriceTable makeupPrices={makeupPrices} />
    </ApeironTooltipInfoButton>
  )
}

type TableProps = {
  makeupPrices: string[]
}

export default CheckInMakeupPriceTableTooltip
